import React from 'react';
import { Routes, Route } from 'react-router-dom'
import UserAnalytics from "../views/admin/user-analytics";
import UserList from "../views/admin/user-list";
import UserVerifactionPending from "../views/admin/user-verfication-panding";
import PendingProject from "../views/admin/pending-project";
import LiveProject from "../views/admin/live-project";
import ProtectedRoute from "./ProtectedRoute";
import ManageAdmin from "../views/admin/manage-admin";
import ManageAdminDetails from "../views/admin/admin-manage-details";
import ProjectShowInertest from "../views/investor/project-show-inertest";
import ProjectManagement from "../views/admin/project-management";
import UserCreatorView from "../views/admin/user-creator-view";
import UserInvestorView from "../views/admin/user-investor-view";
import UserArtistView from "../views/admin/user-artist-view"
import UserDetails from "../views/admin/user-details";
import NotFound from "../views/common/not-found";
import Chats from "../views/common/chat";
import NotificationCenter from "../views/common/notification-center";
import ProfileSettings from "../views/common/profileSettings";
import PasswordSettings from "../views/common/ChangePassword";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route  path='admin'   element={<ProtectedRoute />}>
        <Route  path={'user-analytics'}  element={<UserAnalytics/>}/>
        <Route  path={'user-list'}  element={<UserList/>}/>
        <Route  path={'user-details/:uid'}  element={<UserDetails/>}/>
        <Route  path={'user-list-creator'}  element={<UserCreatorView/>}/>
        <Route  path={'user-list-investor'}  element={<UserInvestorView/>}/>
        <Route  path={'user-list-artist'}  element={<UserArtistView/>}/>
        <Route  path={'user-pending'}  element={<UserVerifactionPending/>}/>
        <Route  path={'project-pending'}  element={<PendingProject/>}/>
        <Route  path={'pending-project-details/:projectId'}  element={<ProjectShowInertest/>}/>
        <Route  path={'live-project-details/:projectId'}  element={<ProjectShowInertest/>}/>
        <Route  path={'project-live'}  element={<LiveProject/>}/>
        <Route  path={'manage'}  element={<ManageAdmin/>}/>
        <Route  path={'manage-admin-details'}  element={<ManageAdminDetails/>}/>
        <Route  path={'project-management'}  element={<ProjectManagement />}/>
        <Route path={'chat'} element={<Chats/>}/>
        <Route path={'notification-center'} element={<NotificationCenter/>}/>
        <Route  path={'settings'} element={<ProfileSettings/>}/>

        <Route path={'password-settings'} element={<PasswordSettings/>}/>

      </Route>
      {/*<Route path="*" element={<NotFound />} />*/}
    </Routes>
  )
}


export default AdminRoutes;